<template>
  <section class="f-share_modal">
    <core-modal-header>{{headerText}}</core-modal-header>
    <core-modal-body>
      <template v-if="shareType === CORE_SHARE_TYPES.digiProject">
        <digitization-completed-project-preview
          :project="shareObject"
          class="mb-1"
        />
      </template>
      <core-share :share-object="shareObject" :share-type="shareType" />
    </core-modal-body>
  </section>
</template>

<script setup>
  const props = defineProps({
    shareType: {
      type: String,
      required: true
    },
    shareObject: {
      type: Object,
      required: true
    }
  });

  const headerText = computed(() => {
    const fileCount = props.shareObject?.files_count || 1;

    switch (props.shareType) {
      case CORE_SHARE_TYPES.tag:
      case CORE_SHARE_TYPES.album:
      case CORE_SHARE_TYPES.file:
      case CORE_SHARE_TYPES.digiFile:
      case CORE_SHARE_TYPES.person:
        return `Share ${props.shareObject?.name}`;
      case CORE_SHARE_TYPES.digiProject:
        return 'Share Digitization Project';
      case CORE_SHARE_TYPES.profile:
        return 'Share Profile';
      case CORE_SHARE_TYPES.container:
        return `Share ${fileCount} File${fileCount > 1 ? 's' : ''}`;
    }
  });
</script>
